<template>
  <div>
    <div id="map-container" class="relative">
      <div
        v-if="tooltipVisible"
        class="tooltip"
        :style="{ left: tooltipX + 'px', top: tooltipY + 'px', opacity: tooltipVisible ? 1 : 0 }"
        v-html="tooltipContent"
      ></div>
      <div v-html="mapSVG"></div>

      <div class="relative inline-block">
        <div v-html="mapSVG"></div>

        <!-- <svg
          :width="SVG_WIDTH"
          :height="SVG_HEIGHT"
          class="absolute top-0 left-0 pointer-events-none"
        >
          <circle
            v-for="(loc, i) in plottedLocations"
            :key="i"
            :cx="loc.x"
            :cy="loc.y"
            r="6"
            fill="red"
            stroke="white"
            stroke-width="2"
            class="cursor-pointer pointer-events-auto"
            @mouseenter="showTooltip($event, loc)"
            @mouseleave="hideTooltip"
          />
        </svg> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapSVG } from './svg-map';

export default {
  props: {
    locations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      MIN_LAT: 49.0,
      MAX_LAT: 54.9,
      MIN_LNG: 14.0,
      MAX_LNG: 24.5,
      SVG_WIDTH: 800,
      SVG_HEIGHT: 600,

      tooltipVisible: false,
      tooltipContent: '',
      tooltipX: 0,
      tooltipY: 0,
    };
  },

  computed: {
    mapSVG() {
      return mapSVG;
    },
    plottedLocations() {
      if (!this.locations || this.locations.length === 0) return [];

      return this.locations.map((location) => {
        const { x, y } = this.projectCoordinates(location.lat, location.lng);
        return {
          ...location,
          x,
          y,
          containerX: x,
          containerY: y,
        };
      });
    },
  },

  methods: {
    projectCoordinates(lat, lng) {
      const normLng = (lng - this.MIN_LNG) / (this.MAX_LNG - this.MIN_LNG);
      const normLat = 1 - (lat - this.MIN_LAT) / (this.MAX_LAT - this.MIN_LAT);

      const x = normLng * this.SVG_WIDTH;
      const y = normLat * this.SVG_HEIGHT;

      return { x, y };
    },

    showTooltip(event, location) {
      this.tooltipContent = `<strong>${location.title}</strong><br><small>${location.type}</small>`;
      this.tooltipVisible = true;

      this.tooltipX = location.containerX;
      this.tooltipY = location.containerY;
    },

    hideTooltip() {
      this.tooltipVisible = false;
    },
  },
};
</script>

<style lang="scss"></style>
